/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The expiration date of the card or token.
 */
export type CardExpiration = {
  month: string;
  year: string;
};

/** @internal */
export const CardExpiration$inboundSchema: z.ZodType<
  CardExpiration,
  z.ZodTypeDef,
  unknown
> = z.object({
  month: z.string(),
  year: z.string(),
});
/** @internal */
export type CardExpiration$Outbound = {
  month: string;
  year: string;
};

/** @internal */
export const CardExpiration$outboundSchema: z.ZodType<
  CardExpiration$Outbound,
  z.ZodTypeDef,
  CardExpiration
> = z.object({
  month: z.string(),
  year: z.string(),
});

export function cardExpirationToJSON(cardExpiration: CardExpiration): string {
  return JSON.stringify(CardExpiration$outboundSchema.parse(cardExpiration));
}
export function cardExpirationFromJSON(
  jsonString: string,
): SafeParseResult<CardExpiration, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CardExpiration$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CardExpiration' from JSON`,
  );
}
